module.exports = __webpack_public_path__ + "static/media/info_icon.4ed3c92b.svg";